import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="faq"
export default class extends Controller {
  static targets = [ "answer", "icon" ]

  toggle() {
    // アイコンを45度回転させるクラスを切り替え
    this.iconTarget.classList.toggle('rotate-45')

    // 回答部分の高さを0とコンテンツ最大高で切り替える
    this.answerTarget.classList.toggle('max-h-0')
    this.answerTarget.classList.toggle('max-h-96') // 回答が収まる十分な高さを指定
  }
}
